<template>
  <ui-dialog
    :show="show"
    :title="title"
    persistent
    scrollable
    @input="$emit('close')"
  >
    <div>
      {{ description }}
    </div>
    <LinkSectionForm
      :data.sync="elements"
      :name.sync="sectionName"
      edit
      ref="sectionForm"
    />
    <template #actions>
      <ui-button outlined color="primary" @click="$emit('close')">
        {{ $t("message.common.cancel") }}
      </ui-button>
      <ui-button
        :loading="loading"
        @click="handleSave"
        color="primary"
        min-width="100"
      >
        {{ $t("message.common.save") }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
import LinkSectionForm from "@/components/StoreLocator/section-forms/LinkSectionForm.vue";

import storeLocatorService from "@/services/storeLocator";
import serviceHandler from "@/helpers/handlers/service";
import { SECTION_TYPES } from "@/enums/section-types.enum";

import { storeLocatorMixin } from "@/helpers/mixins/store-locator";

export default {
  name: "EditSectionDialog",
  components: {
    LinkSectionForm
  },
  mixins: [storeLocatorMixin],
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  created() {
    this.elements = [...this.data.items] || [];
    this.sectionType = this.data.items[0].element_type;
    this.sectionName = this.data.name || "";
  },
  data() {
    return {
      sectionType: null,
      sectionName: null,
      choices: [
        {
          label: this.$t("message.storeLocator.extraInfo.linkSection.label"),
          title: this.$t(
            "message.storeLocator.extraInfo.linkSection.titleEdit"
          ),
          description: this.$t(
            "message.storeLocator.extraInfo.linkSection.description"
          ),
          value: SECTION_TYPES.LINK_SECTION
        }
      ],
      elements: null,
      loading: false
    };
  },
  methods: {
    async handleSave() {
      const isValid = await this.$refs.sectionForm.validate();
      if (!isValid) return;
      const items = this.elements.map(fields => ({
        ...fields,
        element_type: this.sectionType
      }));
      const payload = {
        name: this.sectionName,
        items
      };
      this.loading = true;
      const facilityId = this.$route.params.id;
      const newSection = await serviceHandler(
        storeLocatorService.updateExtraInfoSection(
          facilityId,
          this.data.id,
          payload
        )
      );
      this.loading = false;
      this.$emit("created", newSection);
      this.elements = [];
      this.sectionName = "";
    }
  }
};
</script>
